import { render, staticRenderFns } from "./ModalTitle.vue?vue&type=template&id=398773de&"
import script from "./ModalTitle.vue?vue&type=script&lang=js&"
export * from "./ModalTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports